import Component from '@glimmer/component'
import { service } from '@ember/service'
import { ButtonAppearance, appearanceToThemeClasses } from 'teacher-ui-client/components/ui-button/themes'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'
import { UiButton } from 'teacher-ui-client/components/ui-button'

interface Signature {
  Element: HTMLAnchorElement
  Args: {
    Named: {
      appearance?: ButtonAppearance
      disabled?: boolean
    }
  }
  Blocks: {
    default: []
  }
}

export class UiButtonLink extends Component<Signature> {
  @service subscriptionType!: SubscriptionTypeService

  get themeClasses() {
    return appearanceToThemeClasses(this.args.appearance ?? ButtonAppearance.muted, this.subscriptionType.current).join(
      ' ',
    )
  }

  <template>
    {{! Links can't have the :disabled pseudo-style, and aren't really meant to be "disabled" }}
    {{! To allow us to disable a link, we instead switch it out for a disabled button with no action }}
    {{! There should be no visual difference, other than the disabled styles }}
    {{#if @disabled}}
      <UiButton @disabled={{@disabled}} ...attributes>
        {{yield}}
      </UiButton>
    {{else}}
      {{! href attr is passed in via component usage }}
      {{! template-lint-disable link-href-attributes }}
      <a
        class="inline-block rounded-md px-5 py-2 text-center align-middle no-underline transition-all duration-200 select-none
          {{this.themeClasses}}"
        ...attributes
      >
        {{yield}}
      </a>
    {{/if}}
  </template>
}

export default UiButtonLink
